import Home from '../views/Home.vue'
import userList from '../views/admin/userlist'
import password from "../views/public/password";

let adminRoutes = [
     {
        path: '/',
        component: Home,
        name: '',
        iconCls: 'fa fa-users',
        leaf: true,//只有一个节点
        children: [
            {path: '/users', component: userList, name: 'Users'}
        ]
    },{
        path: '/',
        component: Home,
        name: '',
        iconCls: 'fa fa-user',
        leaf: true,
        children: [
            {path: '/password', component: password, name: 'Password'}
        ]
    }];

export default adminRoutes;





// WEBPACK FOOTER //
// ./src/router/superAdminRouter.js